import { put, call } from 'redux-saga/effects';
import * as accountActions from '../actions/accountActions';
import awsUserInfo from '../api/methods/awsUserInfo';
import Api from '../api/index';
import awsUserResetPassword from '../api/methods/awsUserResetPassword';
//import { showMessage } from 'react-native-flash-message';
//import NavigationService from '../navigation/NavigationService';
//import * as Constants from '../config/constants';
import * as caseActions from '../actions/caseActions';

export function* createAccountSaga(action) {
  var status = 0;
  try {
    console.log('accountSaga:createAccountSaga - Start to create a new user ');
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api('v1/user/', action.accountRequest, 'POST', token);

    if (apiResponse.statusCode === undefined) {
      var errMessage = `Failed to create a new user. ${apiResponse.message}`;
      console.log('accountSaga:createAccountSaga - ', errMessage);
      //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
      yield put(accountActions.createAccountFailed(apiResponse.message));
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      var response = yield put(accountActions.onCreateAccountResponse(apiResponse));
      console.log('Call accountActions.onCreateAccountResponse ', response);
      var msg = 'An account is created for you successfully.';
      console.log(
        'accountSaga:createAccountSaga - A new user is created successfully. User id = ',
        apiResponse.result
      );
      //showMessage({ message: msg, type: 'success', duration: 6000 });
      // reset
      response = yield put(caseActions.clearCase());
      /*var message = Constants.CREATE_ACCOUNT_SUCCESS;
       NavigationService.navigate('SuccessMessage', {
        msg: message,
        toScreen: 'GetStart'
      });*/
    } else {
      if (apiResponse.isError === true) {
        var errorMessage = apiResponse.message === undefined ? '' : apiResponse.message;
        msg = 'Create a new user failed.' + errorMessage;
        /*showMessage({
          message: msg,
          type: 'danger',
          duration: 6000
        });*/
        console.log('accountSaga:createAccountSaga - ', msg);
        yield put(accountActions.createAccountFailed(errorMessage));
      }
    }
  } catch (error) {
    if (error) {
      console.log('accountSaga:createAccountSaga - Create a new user failed.', error);
      msg = 'Create a new user failed.' + error;
      console.log('accountSaga:createAccountSaga - ', errMessage);
      //showMessage({ message: msg, type: 'danger', duration: 6000 });
      yield put(accountActions.createAccountFailed(error));
    }
  }
}

export function* updateAccountFirstNameSaga(action) {
  var status = 0;
  try {
    console.log('accountSaga:updateAccountFirstNameSaga - Start to update user first name ');
    //update aws attributes
    var result = yield call(awsUserInfo.updateUserFirstName, action);
    console.log(
      'accountSaga:updateAccountFirstNameSaga - Update aws first name attribute completed.',
      result
    );

    //update SOP account
    console.log('accountSaga:updateAccountFirstNameSaga - Start to update SOP account first name');
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api(
      'v1/user/firstname',
      { firstname: action.firstName },
      'PUT',
      token
    );
    status = 0;
    if (apiResponse.statusCode === undefined) {
      var errMessage = `Failed to update SOP account first name. ${apiResponse.message}`;
      console.log('accountSaga:updateAccountFirstNameSaga - ', errMessage);
      //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
      yield put(accountActions.updateFirstNameFailed(apiResponse.message));
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(accountActions.onUpdateFirstNameResponse(apiResponse));
      console.log(
        'accountSaga:updateAccountFirstNameSaga - User first name is updated successfully. ',
        apiResponse.result
      );
      //showMessage({ message: msg, type: 'success', duration: 6000 });
    } else {
      if (apiResponse.isError === true) {
        errMessage = `Failed to update SOP account first name. ${status.message}`;
        console.log('accountSaga:updateAccountFirstNameSaga - ', errMessage);
        /*showMessage({
          message: status.message,
          type: 'danger',
          duration: 6000
        });*/
        yield put(accountActions.updateFirstNameFailed(status.message));
      }
    }
  } catch (error) {
    if (error) {
      errMessage = `Failed to update SOP account first name. ${error}`;
      console.log('accountSaga:updateAccountFirstNameSaga - ', error);
      //showMessage({ message: error.message, type: 'danger', duration: 6000 });
      yield put(accountActions.updateFirstNameFailed(error.message));
    }
  }
}

export function* updateAccountLastNameSaga(action) {
  var status = 0;
  try {
    console.log('accountSaga:updateAccountLastNameSaga - Start to update user last name ');
    //update aws attributes
    var result = yield call(awsUserInfo.updateUserLastName, action);
    console.log(
      'accountSaga:updateAccountLastNameSaga - Update aws last name attribute completed.',
      result
    );

    //update SOP account
    var token = yield call(awsUserInfo.currentJwtToken);
    //var email = yield call(awsUserInfo.currentUserEmail);
    const apiResponse = yield Api('v1/user/lastname', { lastname: action.lastName }, 'PUT', token);
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log(
        'accountSaga:updateAccountFirstNameSaga - Failed to update SOP account last name',
        apiResponse.message
      );
      //var errMessage = `Failed to update SOP account last name. ${apiResponse.message}`;
      //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
      yield put(accountActions.updateLastNameFailed(apiResponse.message));
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(accountActions.onUpdateLastNameResponse(apiResponse));
      console.log(
        'accountSaga:updateAccountLastNameSaga - Update user last name successfully. ',
        apiResponse.result
      );
      //showMessage({ message: msg, type: 'success', duration: 6000 });
    } else {
      if (apiResponse.isError === true) {
        console.log(
          'accountSaga:updateAccountLastNameSaga - Update user last name failed:',
          status.message
        );
        /*showMessage({
          message: status.message,
          type: 'danger',
          duration: 6000
        });*/
        yield put(accountActions.updateLastNameFailed(status.message));
      }
    }
  } catch (error) {
    if (error) {
      console.log('accountSaga:updateAccountLastNameSaga - Update user last name failed.', error);
      //showMessage({ message: error.message, type: 'danger', duration: 6000 });
      yield put(accountActions.updateLastNameFailed(error.message));
    }
  }
}

export function* updateAccountEmailSaga(action) {
  var status = 0;
  try {
    console.log('accountSaga:updateAccountEmailSaga - Start to update user email ');
    //update aws attributes
    var result = yield call(awsUserInfo.updateUserEmail, action);
    console.log(
      'accountSaga:updateAccountEmailSaga - Update aws email attribute completed.',
      result
    );

    //update SOP account
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api('v1/user/email', { email: action.email }, 'PUT', token);
    var consoleMsg = `call PUT: v1/user/email body: ${JSON.stringify({
      email: action.email
    })}`;
    console.log(consoleMsg);
    status = 0;
    if (apiResponse.statusCode === undefined) {
      var errMessage = `Failed to update SOP account email. ${apiResponse.message}`;
      console.log(
        'accountSaga:updateAccountEmailSaga - Failed to update SOP account email',
        apiResponse.message
      );
      //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
      yield put(accountActions.updateEmailFailed(apiResponse.message));
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(accountActions.onUpdateEmailResponse(apiResponse));
      console.log(
        'accountSaga:updateAccountEmailSaga - Update user email successfully.',
        apiResponse.result
      );
      //showMessage({ message: msg, type: 'success', duration: 6000 });
    } else {
      if (apiResponse.isError === true) {
        errMessage = `Failed to update SOP account email. ${status.message}`;
        console.log(
          'accountSaga:updateAccountEmailSaga - Update user email failed:',
          status.message
        );
        /*showMessage({
          message: errMessage,
          type: 'danger',
          duration: 6000
        });*/
        yield put(accountActions.updateEmailFailed(errMessage));
      }
    }
  } catch (error) {
    if (error) {
      errMessage = `Failed to update SOP account email. ${error.message}`;
      console.log('accountSaga:updateAccountEmailSaga - Update user email failed.', error);
      //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
      yield put(accountActions.updateEmailFailed(error));
    }
  }
}

export function* updateAccountPhoneSaga(action) {
  var status = 0;
  try {
    console.log('accountSaga:updateAccountPhoneSaga - Start to update user phone ');
    //update aws attributes
    var result = yield call(awsUserInfo.updateUserPhone, action);
    console.log(
      'accountSaga:updateAccountPhoneSaga - Update aws phone attribute completed.',
      result
    );

    //update SOP account
    var token = yield call(awsUserInfo.currentJwtToken);
    //var email = yield call(awsUserInfo.currentUserEmail);
    const apiResponse = yield Api('v1/user/phone', { phone: action.phone }, 'PUT', token);
    var consoleMsg = `call PUT: v1/user/phone body: ${JSON.stringify({
      phone: action.phone.substring(1)
    })}`;
    console.log(consoleMsg);
    status = 0;
    if (apiResponse.statusCode === undefined) {
      //var errMessage = `Failed to update SOP account phone. ${apiResponse.message}`;
      console.log(
        'accountSaga:updateAccountPhoneSaga - Failed to update SOP account phone',
        apiResponse.message
      );
      //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
      yield put(accountActions.updatePhoneFailed(apiResponse.message));
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(accountActions.onUpdatePhoneResponse(apiResponse));
      console.log(
        'accountSaga:updateAccountPhoneSaga - Update user phone successfully.',
        apiResponse.result
      );
      //showMessage({ message: msg, type: 'success', duration: 6000 });
    } else {
      if (apiResponse.isError === true) {
        console.log(
          'accountSaga:updateAccountPhoneSaga - Update user phone failed:',
          status.message
        );
        /*showMessage({
          message: status.message,
          type: 'danger',
          duration: 6000
        });*/
        yield put(accountActions.updatePhoneFailed(status.message));
      }
    }
  } catch (error) {
    if (error) {
      console.log('accountSaga:updateAccountPhoneSaga - Update user phone failed.', error);
      //showMessage({ message: error.message, type: 'danger', duration: 6000 });
      yield put(accountActions.updatePhoneFailed(error.message));
    }
  }
}

// Our worker Saga that reset password
export function* updatePasswordSaga(action) {
  try {
    console.log('accountSaga:updateAccountEmailSaga - Start to update user password ');
    var data = yield call(awsUserResetPassword.changePassword, action);
    console.log('accountSaga:updatePasswordSaga - Update aws password completed.', data);

    if (data !== 'SUCCESS') {
      yield put(accountActions.updatePasswordFailed(data.message));
      console.log(
        'accountSaga:updatePasswordSaga - Failed to login. Error from AWS:',
        data.message
      );
      /*showMessage({
        message: 'Change password failed',
        type: 'danger',
        duration: 6000
      });*/
    } else {
      yield put(accountActions.onUpdatePasswordResponse(action.newPassword));
      console.log('accountSaga:updatePasswordSaga - Update user password successfully');
      /*showMessage({
        message: 'Change password is successful',
        type: 'success',
        duration: 6000
      });*/
    }
  } catch (error) {
    console.log('accountSaga:updatePasswordSaga - error reset password ', error);
    /*showMessage({
      message: 'Change password failed',
      type: 'danger',
      duration: 6000
    });*/
  }
}
export function* getPhoneSaga() {
  var status = 0;
  try {
    console.log('accountSaga:getPhoneSaga - Start to get my phone ');
    var token = yield call(awsUserInfo.currentJwtToken);
    var uri = encodeURI('v1/user/phone');
    console.log('call GET url: ', encodeURI(uri));
    const apiResponse = yield Api(encodeURI(uri), null, 'GET', token);
    console.log('Response: ', apiResponse);
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log('accountSaga:getPhoneSaga - Failed to get my phone', apiResponse.message);
      var errorMessage = apiResponse.message === undefined ? '' : apiResponse.message;
      yield put(accountActions.getPhoneFailed(apiResponse.message));
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(accountActions.onGetPhoneResponse(apiResponse.result));
      console.log('Call accountActions.onGetPhoneResponse ', apiResponse.result);
    } else {
      if (apiResponse.isError === true) {
        errorMessage = apiResponse.message === undefined ? '' : apiResponse.message;
        yield put(accountActions.getPhoneFailed(errorMessage));
      }
    }
  } catch (error) {
    if (error) {
      yield put(accountActions.getPhoneFailed(error));
    }
  }
}
